var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"border":"","auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight,"size":"small","row-id":"amzSkuStoreCode","seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize },"radio-config":!_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            strict: false,
            reserve: _vm.reserve,
          }
        : {},"checkbox-config":_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            reserve: _vm.reserve,
          }
        : {}},on:{"radio-change":_vm.radioChange,"checkbox-change":_vm.checkboxChange,"checkbox-all":_vm.checkboxChange},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"sellType",fn:function(ref){
        var row = ref.row;
return [(row.v_sellType)?_c('el-tag',{attrs:{"size":"mini","type":row.sellType === 'A'
            ? ''
            : row.sellType === 'B'
            ? 'success'
            : 'warning'}},[_vm._v(" "+_vm._s(row.v_sellType)+" ")]):_vm._e()]}},{key:"salesTitle",fn:function(ref){
            var row = ref.row;
return [(!row.salesUrl)?_c('span',[_vm._v(_vm._s(row.salesTitle))]):_vm._e(),(!!row.salesUrl)?_c('el-link',{attrs:{"type":"primary","href":row.salesUrl,"underline":false,"target":"_blank"}},[_vm._v(" "+_vm._s(row.salesTitle)+" ")]):_vm._e()]}},{key:"status",fn:function(ref){
            var row = ref.row;
return [(row.v_storeSkuStatus)?_c('el-tag',{attrs:{"size":"mini","type":row.storeSkuStatus === 'Y'
            ? 'success'
            : row.storeSkuStatus === 'S'
            ? 'danger'
            : ''}},[_vm._v(" "+_vm._s(row.v_storeSkuStatus)+" ")]):_vm._e()]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }